import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { useAuth0 } from "@auth0/auth0-react";
import styles from './CurrentEventUsers.module.css';
import { selectCurrentPartyEvent,  } from '../currentPartyEvent/currentPartyEventSlice'
import { selectCurrentEventUsers, loadEventUsersAsync, changeAttendingStatusAsync } from './currentEventUsersSlice'
import { Page } from '../../Page'
import { setAlias, setUserEmail } from '../addEventUser/currentEventUserSlice';
import { resetButtons, setBackButtonVisible, setAddEventUserVisible, setNotificationsButtonVisible, setInformationButtonVisible, setHomeButtonVisible } from '../menu/menuSlice'
import { MessageBoxAction, setMessage, setMessageBoxAction } from '../messageBoxes/messageBoxSlice';
import { setAttendeeEmail } from '../currentAttendee/currentAttendeeSlice';
import { transmissionDateToDisplayableDateTime } from '../../utils/dateUtils';
import { BackButton } from '../menu/BackButton';

export function CurrentEventUsers() {
    const { isAuthenticated, getAccessTokenSilently, user } = useAuth0()
    const currentPartyEvent = useAppSelector(selectCurrentPartyEvent)
    const currentEventUsers = useAppSelector(selectCurrentEventUsers)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [filterStatus, setFilterStatus] = useState(-1)

    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setAddEventUserVisible(true))
        dispatch(setNotificationsButtonVisible(true))
        dispatch(setHomeButtonVisible(true))
        dispatch(setInformationButtonVisible(false))


    }, [dispatch])

    useEffect(() => {
        const getUserMetadata = async () => {
          if (isAuthenticated) {  
            try {
                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                }})
                if (currentPartyEvent?.id) {
                    dispatch(loadEventUsersAsync({ 
                                    partyEventId: currentPartyEvent.id,
                                    token: accessToken
                                }))
                }
            } catch  {
                console.log("Error occured getting token or getting event users");
            }
          }
        };
      
        getUserMetadata();
        
      }, [dispatch, getAccessTokenSilently, isAuthenticated, navigate, currentPartyEvent]);

    return(
        <Page>
            <div className={styles.bannerContainer}>
                <div>
                <h2>PartyPlanner.</h2>
                <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <div className={styles.buttons}>
                    <BackButton/>
                <div className={styles.bannerButton} onClick={()=> {
                        dispatch(setAlias(''))
                        dispatch(setUserEmail(''))
                        navigate('/AddEventUser')
                    }}>Add Attendee
                </div>
            </div>
            </div>
            <div className={styles.currentEventInfoPanel}>
                <h2>{currentPartyEvent?.title}</h2>
                <div className={styles.currentEventSubInfoPanel}>
                    <p>{currentPartyEvent?.location}</p>
                    <p>{currentPartyEvent?.start ? transmissionDateToDisplayableDateTime(currentPartyEvent?.start): 'No Start Time' } </p>
                </div>
            </div>

            <div className={styles.searchFilter}>
            <label>Show</label>
            <select className={styles.selectAttendingStatus} defaultValue={-1} onClick={(e) => {e.stopPropagation() }} 
                 onChange={async(e) => {
                    setFilterStatus(parseInt(e.target.value))
                 }}>        
                <option className={styles.all} value='-1'>All</option>
                <option className={styles.noResponse} value='0'>No Response</option>
                <option className={styles.attending} value='1'>Attending</option>
                <option className={styles.declining} value='2'>Declined</option>
                <option className={styles.maybe} value='3'>Maybe</option>
            </select>
            </div>
            
            {isAuthenticated && currentEventUsers?.map((eventUser) => {
                return (
                    filterStatus== -1 || filterStatus== eventUser.attendingStatus  ? 
                    <div className={styles.eventUserPanel} key={eventUser.email} onClick = {(() => {
                        dispatch(setAlias(eventUser.alias??''))
                        dispatch(setUserEmail(eventUser.email))
                        navigate('/EditEventUser')
                    })}>
                        <h3>   {eventUser.alias && eventUser.alias?.trim().length>0 ? eventUser.alias:eventUser.email }</h3>
                        <div className={styles.attendingInformation}>
                            <select className={styles.selectAttendingStatus} defaultValue={eventUser.attendingStatus} onClick={(e) => {e.stopPropagation() }}      onChange={async(e) => {
                                           e.stopPropagation()
                                           if (isAuthenticated) {  
                                               try {
                                                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                                                }})
                                                   if (currentPartyEvent?.id != null )  {
                                                       dispatch(changeAttendingStatusAsync({ 
                                                           partyEventId: currentPartyEvent.id,
                                                           email: eventUser.email,
                                                           token: accessToken,
                                                           attendingStatus: Number(e.target.value),
                                                           alias: eventUser.alias
                                                       }))
                  
                                                   }
                                               } catch (error)  {
                                                   
                                               }
                                             }
                            }}>
                                
                                <option className={styles.noResponse} value='0'>No Response</option>
                                <option className={styles.attending} value='1'>Attending</option>
                                <option className={styles.declining} value='2'>Declined</option>
                                <option className={styles.maybe} value='3'>Maybe</option>
                            </select>
                        </div>
                        
                        <div className = {styles.eventUserDeletePanel}>
                         <button className = {styles.deleteUser} onClick={ async(e) => {
                             e.stopPropagation()
                             dispatch(setAttendeeEmail(eventUser.email)) 
                             let msg = `Delete '${eventUser.alias ?? eventUser.email}'?`
                            if (eventUser.email == user?.email){
                                msg += ' You are deleting yourself. You will not be able to view this party later.'
                            }
                             dispatch(setMessage(msg))
                             dispatch(setMessageBoxAction(MessageBoxAction.DeleteAttendee))
                             navigate('/MessageBox')
                         }
                            }
                            >Delete</button>
                        </div>
                    </div>
                : null   
            )
            })}
            {/* <div className={styles.addAttendeeButton} onClick={()=> {
                dispatch(setAlias(''))
                dispatch(setUserEmail(''))
                navigate('/AddEventUser')
            }}><p>Add Attendee </p></div> */}
                <br></br>
                <br></br>
                <br></br>
        </Page>
    )
}